module.exports = "//static.hsappstatic.net/ContentComponents/static-2.62696/img/content-remix-post-publish/content-remix-de.png"